	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.AABB;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/AABB.js
// module id = 25
// module chunks = 0